function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.define-property.js";

/*
 *  Our Story Family Section
 *    Scripts for the family carousel
 *
 *  Version:
 *    1.0.0 - 2020/10/19
 */
import { initCarousel } from "../../objects/carousel";
import { responsiveMediaAbove, responsiveMediaBelow, responsiveQuery } from './../../settings/responsive'; // Selectors

var SELECTOR_FAMILY_CONTAINER = '[data-our-family]';
var SELECTOR_FAMILY_WRAP = '[data-our-family-carousel]';
var SELECTOR_FAMILY_PROGRESS = '[data-our-family-progress]';
var SELECTOR_FAMILY_TILE = '[data-family-tile]';
var BUTTON_NEXT = '[data-carousel-next]';
document.querySelectorAll(SELECTOR_FAMILY_CONTAINER).forEach(function (element) {
  var _breakpoints;

  var slides = element.querySelectorAll(SELECTOR_FAMILY_TILE);
  var progressBar = element.querySelector(SELECTOR_FAMILY_PROGRESS);
  var carouselWrap = element.querySelector(SELECTOR_FAMILY_WRAP);
  var next = element.querySelector(BUTTON_NEXT);
  if (!progressBar || !carouselWrap || !next) return;
  var keenCarousel = initCarousel(carouselWrap, {
    slidesPerView: 1.4,
    loop: true,
    dragSpeed: 2,
    breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, responsiveQuery('SMALL'), {
      slidesPerView: 2.4
    }), _defineProperty(_breakpoints, responsiveQuery('MEDIUM'), {
      slidesPerView: 2.8
    }), _defineProperty(_breakpoints, responsiveQuery('LARGE'), {
      slidesPerView: 3.3
    }), _defineProperty(_breakpoints, responsiveQuery('XLARGE'), {
      slidesPerView: 3.67
    }), _breakpoints)
  }, undefined, undefined, next, undefined, progressBar);
});